import { render, staticRenderFns } from "./courseParticipant.vue?vue&type=template&id=137102aa&scoped=true&"
import script from "./courseParticipant.vue?vue&type=script&lang=js&"
export * from "./courseParticipant.vue?vue&type=script&lang=js&"
import style0 from "./courseParticipant.vue?vue&type=style&index=0&id=137102aa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137102aa",
  null
  
)

export default component.exports